import { Component, OnInit, Input } from '@angular/core';
import QRCode from 'qrcode';
import { ModalController } from '@ionic/angular';
import { Storage } from "@ionic/storage";
import { AppStorageKey } from "src/app/static";

@Component({
  selector: 'app-qr-access',
  templateUrl: './qr-access.component.html',
  styleUrls: ['./qr-access.component.scss'],
})
export class QrAccessComponent implements OnInit {

  @Input() data: any;

  qrCode: string;

  timeinterval: any;

  constructor(
    public modalController : ModalController,
    private storage: Storage
  ) { }

  async ngOnInit() {
    let CurrentDate = new Date();
    let expirationDate = new Date(CurrentDate);
    this.addMinutes(expirationDate,1);
    let data = {
      ...this.data,
      fechaVencimiento: this.formatDate(expirationDate)
    };
    let qrCodeData = await this.storage.get(AppStorageKey.QrCode);
    if(qrCodeData){
      let qrDate = new Date(qrCodeData.fechaVencimiento);
      if(CurrentDate > qrDate){
        this.generateQrCode(data);
        this.initializeClock('clockdiv', expirationDate.toString());
        this.saveQrCode(data);
      }else{
        this.initializeClock('clockdiv', qrDate.toString());
        this.qrCode = qrCodeData.image
      }
    }else{
      this.generateQrCode(data);
      this.initializeClock('clockdiv', expirationDate.toString());
      this.saveQrCode(data);
    }
  }

  addMinutes(date, minutes) {
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }

  generateQrCode(data){
    let qrData = `{ Nombre: ${data.nombre}, Empleado: ${data.numeroEmpleado}, Vencimiento: ${data.fechaVencimiento} }`;
    QRCode.toDataURL(qrData, { width: 265 }, (err, url) => {
      if (err) {
        console.error(err);
        return;
      }
      this.qrCode = url; // URL del código QR generado
    });
  }

  regenerateQrCode(){
    let expirationDate = new Date();
    this.addMinutes(expirationDate,1);
    let data = {
      ...this.data,
      fechaVencimiento: this.formatDate(expirationDate)
    };
    this.generateQrCode(data);
    clearInterval(this.timeinterval);
    this.initializeClock('clockdiv', expirationDate.toString());
    this.saveQrCode(data);
  }

  padTwoDigits(num: number) {
    return num.toString().padStart(2, "0");
  }
  
  formatDate(date: Date, dateDiveder: string = "-") {
    return (
      [
        date.getFullYear(),
        this.padTwoDigits(date.getMonth() + 1),
        this.padTwoDigits(date.getDate()),
      ].join(dateDiveder) +
      " " +
      [
        this.padTwoDigits(date.getHours()),
        this.padTwoDigits(date.getMinutes()),
        this.padTwoDigits(date.getSeconds()),
      ].join(":")
    );
  }

  saveQrCode(qrData){
    this.storage.set(AppStorageKey.QrCode,{ ...qrData, image: this.qrCode });
  }

  closeModal(){
    this.modalController.dismiss();
    clearInterval(this.timeinterval);
  }

  initializeClock(id, endtime) {
    const clock = document.getElementById(id);
    const secondsSpan = clock.querySelector('.seconds');
    const self = this;
  
    function updateClock() {
      const t = self.getTimeRemaining(endtime);
      secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
      if (t.total <= 0) {
        clearInterval(this.timeinterval);
        self.regenerateQrCode();
      }
    }
  
    updateClock();
    this.timeinterval = setInterval(updateClock, 1000);
  }

  getTimeRemaining(endtime){
    const total = Date.parse(endtime) - Date.parse(new Date().toString());
    const seconds = Math.floor( (total/1000) % 60 );
    return {
      total,
      seconds
    };
  }
}
